import ButtonSystem from './ButtonSystem';
import './ButtonSystem.scss';

export default ButtonSystem;
